import { I18n } from '@front/volcanion'
import moment from 'moment'

class Callbacks {
  static handleSendCommentHandler(createComment, record_id, openNotification) {
    return async function handleSendComment(values) {
      const { text, type, title } = values
      try {
        if (!text) openNotification(I18n.t('toast.comment.error.empty'), { variant: 'warning' })
        else {
          await createComment({ data: { text, type, title, category: 'JFPNk9Qxj', orders: [record_id] } })
          openNotification(I18n.t('toast.comment.success.order'), { variant: 'success' })
        }
      } catch (err) {
        openNotification(I18n.t('toast.comment.error.default'), { variant: 'error' })
      }
    }
  }
  static handleOpenSendCommentDialogHandler(openDialog) {
    return function handleOpenSendCommentDialog() {
      openDialog('order_send_comment', { popupTitle: I18n.t('comment.operator') })
    }
  }

  static handleBeforeManualDispatchHandler(openNotification) {
    return function handleBeforeManualDispatch(values, extra, meta, state) {
      const { user_id } = values
      if (!user_id) {
        openNotification(I18n.t('toast.driver.error.code_incorrect'), { variant: 'error' })
        return false
      }
      return true
    }
  }

  static handleManualDispatchHandler(dispatchJob, order_id, openNotification) {
    return async function handleManualDispatch(values, extra) {
      const { user_id } = values
      const { job_id, options } = extra || {}

      try {
        await dispatchJob({ order_id, job_id, user_id, options: { skip_blacklist: true, ...options } })
        openNotification(I18n.t('order.request_manual_dispatch'), { variant: 'info' })
      } catch (err) {
        return openNotification(I18n.t('toast.manual_dispatch.error.default'), { variant: 'error' })
      }
    }
  }
  static handleOpenManualDispatchHandler(openDialog, record, canManualDispatch, handleCall) {
    return function handleOpenManualDispatch(force) {
      if (!canManualDispatch)
        return

      const transportStarted = !_.isEmpty(_.get(record, 'assigned_transport'))
        && !_.includes(['planned', 'canceled', 'complete'], _.get(record, 'assigned_transport.status'))

      if (_.isEmpty(record, 'job') && !force)
        openDialog('default_dialog_information', {
          title: I18n.t('dispatch.no_manual.title'),
          description: I18n.t('dispatch.no_manual.text')
        })
      else if (!!transportStarted && !force)
        openDialog('default_dialog_information', {
          title: I18n.t('dispatch.transport_started.title'),
          description: I18n.t('dispatch.transport_started.text'),
        })
      else if (_.get(record, 'status') === 'attributed' && !force) {
        openDialog('dispatch_confirmation', {
          title: I18n.t('order.attributed'),
          description: I18n.t('error.order_already_attributed_dispatch', { driver_code: _.get(record, 'assigned_transport.driver.info.user_client_id') }),
        })
      }
      else
        openDialog('dispatch_manual_form', {
          title: I18n.t('dispatch.manual.label', { count: 1 }),
          job_id: _.get(record, 'job'),
          handleCall
        }, { job_id: _.get(record, 'job') })
    }
  }
  static handleOpenSendMessageDriverHandler(openDialog) {
    return function handleOpenSendMessageDriver() {
      openDialog('order_send_message_driver', { popupTitle: I18n.t('driver.alert') })
    }
  }
  static handleSendMessageDriverHandler(sendDriverMessage, driver_id, openNotification) {
    return async function handleSendMessageDriverHandler(values) {
      const { title, text } = values
      try {
        if (!text || !driver_id) {
          openNotification(I18n.t('toast.comment.error.empty'), { variant: 'warning' })
        } else {
          await sendDriverMessage({
            data: {
              type: 'alert',
              title: title,
              body: text,
              drivers: [driver_id]
            }
          })
          openNotification(I18n.t('toast.comment.success.save'), { variant: 'success' })
        }
      } catch (err) {
        openNotification(I18n.t('toast.comment.error.default'), { variant: 'error' })
      }
    }
  }
  static handleOpenRedispatchHandler(openDialog, status, driver_client_id, driver_full_name) {
    return function handleOpenRedispatch() {
      openDialog('redispatch_confirmation', {
        title: I18n.t('order.redispatch_confirmation.title'),
        description: status === 'attributed' ? I18n.t('error.order_already_attributed_redispatch', { driver_code: driver_client_id, driver_full_name })
          : I18n.t('order.redispatch_confirmation.body')
      })
    }
  }
  static handleRedispatchHandler(dispatchJob, job_id, order_id, openNotification) {
    return async function handleRedispatchHandler(values) {
      try {
        await dispatchJob({
          job_id,
          order_id,
          options: {
            skip_blacklist: true,
            reason: values?.reason,
            cancelation_comment: values?.cancelation_comment
          }
        })
        openNotification(I18n.t('toast.message.success.reassign'), { variant: 'success' })
      } catch (e) {
        openNotification(I18n.t('toast.message.error.reassign'), { variant: 'error' })
      }
    }
  }
  static handleOpenClaimRedispatchHandler(openDialog, customerClaim, record) {
    return async function handleOpenClaimRedispatch() {
      if (!record || _.get(record, 'status') === 'complete') return
      const eta = _.get(record, 'assigned_transport.info.src_datetime') || _.get(record, 'info.src_datetime')
      const data = !!eta ? [{
        key: 'eta',
        value: moment.utc(eta).diff(moment.utc(), 'minutes'),
        type: 'duration',
        unit: 'm'
      }] : null

      customerClaim({ data: { name: 'customer_claim', data, order: _.get(record, 'order_id'), active: false } })
      if (_.get(record, 'status') !== 'canceled') return
      openDialog('claim_confirmation', {
        title: I18n.t('order.redispatch_confirmation.title'),
        description: I18n.t('order.redispatch_confirmation.body'),
      })
    }
  }
  static handleOpenCancelConfirmationDialogHandler(openDialog, order_id, order_status, driver_client_id, driver_full_name) {
    return function handleOpenCancelConfirmationDialog(isGrouped) {
      if (!!isGrouped)
        openDialog('cancel_order_grouped', {
          title: I18n.t('order.cancel'),
          order_id
        })
      else {
        openDialog('cancel_confirmation', {
          title: I18n.t(`order.cancel`),
          description: order_status === 'attributed'
            ? I18n.t('error.order_already_attributed_cancel', { driver_code: driver_client_id, driver_full_name })
            : I18n.t('order.cancel_confirm', { order_client_id: '' })
        })
      }
    }
  }
}


export default Callbacks
